/**
 * Created by Danish on 27/06/2017.
 */
export class PlumberDetails {
  drainerName: string;
  drainerPhoneNumber: string;
  drainerLicenseNumber: string;
  drinkingWaterPlumberName: string;
  drinkingWaterPlumberCompany: string;
  drinkingWaterPlumberPhoneNumber: string;
  drinkingWaterPlumberLicenseNumber: string;
  recycledWaterPlumberName: string;
  recycledWaterPlumberPhoneNumber: string;
  recycledWaterPlumberLicenseNumber: string;
  errorMessage: string;

  constructor() {
  this.errorMessage = null;
  }

  toUpperCase() {
    if (this.drainerName) {
      this.drainerName = this.drainerName.toUpperCase();
    }

    if (this.drainerPhoneNumber) {
      this.drainerPhoneNumber = this.drainerPhoneNumber.toUpperCase();
    }

    if (this.drainerLicenseNumber) {
      this.drainerLicenseNumber = this.drainerLicenseNumber.toUpperCase();
    }

    if (this.drinkingWaterPlumberName) {
      this.drinkingWaterPlumberName = this.drinkingWaterPlumberName.toUpperCase();
    }

    if (this.drinkingWaterPlumberCompany) {
      this.drinkingWaterPlumberCompany = this.drinkingWaterPlumberCompany.toUpperCase();
    }

    if (this.drinkingWaterPlumberPhoneNumber) {
      this.drinkingWaterPlumberPhoneNumber = this.drinkingWaterPlumberPhoneNumber.toUpperCase();
    }

    if (this.drinkingWaterPlumberLicenseNumber) {
      this.drinkingWaterPlumberLicenseNumber = this.drinkingWaterPlumberLicenseNumber.toUpperCase();
    }

    if (this.recycledWaterPlumberName) {
      this.recycledWaterPlumberName = this.recycledWaterPlumberName.toUpperCase();
    }

    if (this.recycledWaterPlumberPhoneNumber) {
      this.recycledWaterPlumberPhoneNumber = this.recycledWaterPlumberPhoneNumber.toUpperCase();
    }

    if (this.recycledWaterPlumberLicenseNumber) {
      this.recycledWaterPlumberLicenseNumber = this.recycledWaterPlumberLicenseNumber.toUpperCase();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/plumber-details.ts